import { render } from "./AboutTab.vue?vue&type=template&id=ac4af9b6&scoped=true"
import script from "./AboutTab.vue?vue&type=script&lang=js"
export * from "./AboutTab.vue?vue&type=script&lang=js"

import "./AboutTab.vue?vue&type=style&index=0&id=ac4af9b6&lang=css"
import "./AboutTab.vue?vue&type=style&index=1&id=ac4af9b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac4af9b6"]])

export default __exports__